import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface IYuklemePlanAracIslemleri_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IYuklemePlanAracIslemleri_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  ReadFromSessionStorage: string;
  ReadFromSessionStorage_dummy: string;
  Get_Helpers_UserInfoByUserName: any[];
  Get_Helpers_UserInfoByUserName_dummy: any[];
  Get_Firma_ParametreByName: any[];
  Get_Firma_ParametreByName_dummy: any[];
  Get_AracYuklemeBilgi: any[];
  Get_AracYuklemeBilgi_dummy: any[];
  Notify: boolean;
  Notify_dummy: boolean;
  GetAracKantarFarkMailBody: string;
  GetAracKantarFarkMailBody_dummy: string;
  YuklemePlan_SaveKantarFark: number;
  YuklemePlan_SaveKantarFark_dummy: number;
  SendMail: boolean;
  SendMail_dummy: boolean;
  Subtract: number;
  Subtract_dummy: number;
  SetValueOf: any;
  SetValueOf_dummy: any;
  KantarFarkHesapla: number;
  KantarFarkHesapla_dummy: number;
  YuklemePlan_AracDurumGuncelle: number;
  YuklemePlan_AracDurumGuncelle_dummy: number;
  IfThenElse: boolean;
  IfThenElse_dummy: boolean;
  YuklemePlan_SaveSmsLink: number;
  YuklemePlan_SaveSmsLink_dummy: number;
  GetTextForSMS: any[];
  GetTextForSMS_dummy: any[];
  Sms_Send: string;
  Sms_Send_dummy: string;
  ForEach2: GetTextForSMS;
  ForEach2_dummy: GetTextForSMS;
  YuklemePlan_SaveSmsResult: number;
  YuklemePlan_SaveSmsResult_dummy: number;
  YuklemePlan_Get_MikroDagitimDepoListe: any[];
  YuklemePlan_Get_MikroDagitimDepoListe_dummy: any[];
  YuklemePlan_Get_MikroDagitimNoktaListe: any[];
  YuklemePlan_Get_MikroDagitimNoktaListe_dummy: any[];
  GetMailBody_MikroDagitimDepoBilgilendirme: string;
  GetMailBody_MikroDagitimDepoBilgilendirme_dummy: string;
  isComp896232Visible: "visible" | "hidden";
  isComp312807Enabled: "enabled" | "disabled";
  isComp268195Enabled: "enabled" | "disabled";
  isComp515477Enabled: "enabled" | "disabled";
  isComp975101Enabled: "enabled" | "disabled";
  isComp739452Enabled: "enabled" | "disabled";
  isComp571924Enabled: "enabled" | "disabled";
  isComp275391Enabled: "enabled" | "disabled";
  isComp267922Enabled: "enabled" | "disabled";
  isComp423966Enabled: "enabled" | "disabled";
  isComp460914Enabled: "enabled" | "disabled";
  isComp485178Enabled: "enabled" | "disabled";
  isComp723285Enabled: "enabled" | "disabled";
  isComp826476Enabled: "enabled" | "disabled";
  isComp494956Enabled: "enabled" | "disabled";
  isComp296908Enabled: "enabled" | "disabled";
  isComp297996Enabled: "enabled" | "disabled";
}

export class YuklemePlanAracIslemleri_ScreenBase extends React.PureComponent<
  IYuklemePlanAracIslemleri_ScreenProps,
  any
> {
  yuklemeplanaracislemleri_275391_value_kuikaDatetimeRef: React.RefObject<any>;
  yuklemeplanaracislemleri_494956_value_kuikaDatetimeRef: React.RefObject<any>;
  yuklemeplanaracislemleri_296908_value_kuikaDatetimeRef: React.RefObject<any>;
  yuklemeplanaracislemleri_297996_value_kuikaDatetimeRef: React.RefObject<any>;
  ml = [
    {
      Id: "585b6303-ac4a-473f-8893-c915ede3bf84",
      Name: "en_US",
      ShortName: "English",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "71c6969d-6e7e-4c09-9ad1-ec4691653f76",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        {
          Id: 765620,
          PropertyName: "value",
          Value: "Aruna Nakliye Yönetim Portalı",
        },
        { Id: 655502, PropertyName: "value", Value: "Sürücü TC Kimlik No" },
        { Id: 59594, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 987747, PropertyName: "label", Value: "Bilgileri Getir" },
        { Id: 601295, PropertyName: "value", Value: "Yükleme No" },
        { Id: 312807, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 799222, PropertyName: "value", Value: "Taşıyıcı Firma" },
        { Id: 268195, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 912904, PropertyName: "value", Value: "Sürücü Adı" },
        { Id: 515477, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 263250, PropertyName: "value", Value: "Sürücü Cep Telefonu" },
        { Id: 975101, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 25183, PropertyName: "value", Value: "Plaka" },
        { Id: 739452, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 653505, PropertyName: "value", Value: "Dorse Plaka" },
        { Id: 571924, PropertyName: "placeholder", Value: "Type here..." },
        {
          Id: 833559,
          PropertyName: "value",
          Value: "Tahmini Varış Tarih / Saat",
        },
        {
          Id: 275391,
          PropertyName: "placeholder",
          Value: "Select Date Time...",
        },
        { Id: 343192, PropertyName: "value", Value: "Varış Noktası" },
        { Id: 267922, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 635081, PropertyName: "value", Value: "KYP Ağırlık" },
        { Id: 423966, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 579933, PropertyName: "value", Value: "Kantar Farkı" },
        { Id: 460914, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 896232, PropertyName: "label", Value: "Fark Bildir" },
        { Id: 567017, PropertyName: "value", Value: "Net Ağırlık" },
        { Id: 485178, PropertyName: "placeholder", Value: "0" },
        { Id: 226984, PropertyName: "value", Value: "Giriş Ağırlık" },
        { Id: 601643, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 412881, PropertyName: "value", Value: "Çıkış Ağırlık" },
        { Id: 189286, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 723285, PropertyName: "label", Value: "Araç Geldi" },
        { Id: 826476, PropertyName: "label", Value: "Yüklemeye Alındı" },
        { Id: 314442, PropertyName: "label", Value: "Fabrika Çıkış Yapıldı" },
        {
          Id: 494956,
          PropertyName: "placeholder",
          Value: "Select Date Time...",
        },
        {
          Id: 296908,
          PropertyName: "placeholder",
          Value: "Select Date Time...",
        },
        {
          Id: 297996,
          PropertyName: "placeholder",
          Value: "Select Date Time...",
        },
      ],
    },
  ];
  defaultML = "en_US";

  screenHash = "";

  constructor(props) {
    super(props);
    this.yuklemeplanaracislemleri_59594_value_kuikaTextInputRef =
      React.createRef();
    this.yuklemeplanaracislemleri_312807_value_kuikaTextInputRef =
      React.createRef();
    this.yuklemeplanaracislemleri_268195_value_kuikaTextInputRef =
      React.createRef();
    this.yuklemeplanaracislemleri_515477_value_kuikaTextInputRef =
      React.createRef();
    this.yuklemeplanaracislemleri_975101_value_kuikaTextInputRef =
      React.createRef();
    this.yuklemeplanaracislemleri_739452_value_kuikaTextInputRef =
      React.createRef();
    this.yuklemeplanaracislemleri_571924_value_kuikaTextInputRef =
      React.createRef();
    this.yuklemeplanaracislemleri_275391_value_kuikaDatetimeRef =
      React.createRef();
    this.yuklemeplanaracislemleri_267922_value_kuikaTextInputRef =
      React.createRef();
    this.yuklemeplanaracislemleri_423966_value_kuikaTextInputRef =
      React.createRef();
    this.yuklemeplanaracislemleri_460914_value_kuikaTextInputRef =
      React.createRef();
    this.yuklemeplanaracislemleri_485178_value_kuikaTextInputRef =
      React.createRef();
    this.yuklemeplanaracislemleri_601643_value_kuikaTextInputRef =
      React.createRef();
    this.yuklemeplanaracislemleri_189286_value_kuikaTextInputRef =
      React.createRef();
    this.yuklemeplanaracislemleri_494956_value_kuikaDatetimeRef =
      React.createRef();
    this.yuklemeplanaracislemleri_296908_value_kuikaDatetimeRef =
      React.createRef();
    this.yuklemeplanaracislemleri_297996_value_kuikaDatetimeRef =
      React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      NAVIGATE: "",
      ReadFromSessionStorage: "",
      Get_Helpers_UserInfoByUserName: [],
      Get_Firma_ParametreByName: [],
      Get_AracYuklemeBilgi: [],
      Notify: false,
      GetAracKantarFarkMailBody: "",
      YuklemePlan_SaveKantarFark: 0,
      SendMail: false,
      Subtract: 0,
      SetValueOf: "",
      KantarFarkHesapla: 0,
      YuklemePlan_AracDurumGuncelle: 0,
      IfThenElse: false,
      isComp896232Visible: "hidden",
      isComp312807Enabled: "disabled",
      isComp268195Enabled: "disabled",
      isComp515477Enabled: "disabled",
      isComp975101Enabled: "disabled",
      isComp739452Enabled: "disabled",
      isComp571924Enabled: "disabled",
      isComp275391Enabled: "disabled",
      isComp267922Enabled: "disabled",
      isComp423966Enabled: "disabled",
      isComp460914Enabled: "disabled",
      isComp485178Enabled: "disabled",
      isComp723285Enabled: "disabled",
      isComp826476Enabled: "disabled",
      isComp494956Enabled: "disabled",
      isComp296908Enabled: "disabled",
      isComp297996Enabled: "disabled",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("yuklemeplanaracislemleri", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.YuklemePlanAracIslemleriPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("yuklemeplanaracislemleri", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("yuklemeplanaracislemleri", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.YuklemePlanAracIslemleriPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({
      yuklemeplanaracislemleri_312807_value:
        this.state.Get_AracYuklemeBilgi?.at?.(0)?.yuklemeNo ?? undefined,
      yuklemeplanaracislemleri_268195_value:
        this.state.Get_AracYuklemeBilgi?.at?.(0)?.tasiyiciFirmaAdi ?? undefined,
      yuklemeplanaracislemleri_515477_value:
        this.state.Get_AracYuklemeBilgi?.at?.(0)?.surucuAdi ?? undefined,
      yuklemeplanaracislemleri_975101_value:
        this.state.Get_AracYuklemeBilgi?.at?.(0)?.surucuGSM ?? undefined,
      yuklemeplanaracislemleri_739452_value:
        this.state.Get_AracYuklemeBilgi?.at?.(0)?.plaka ?? undefined,
      yuklemeplanaracislemleri_571924_value:
        this.state.Get_AracYuklemeBilgi?.at?.(0)?.dorsePlaka ?? undefined,
      yuklemeplanaracislemleri_275391_value:
        this.state.Get_AracYuklemeBilgi?.at?.(0)?.tahminiGelis ?? undefined,
      yuklemeplanaracislemleri_267922_value:
        this.state.Get_AracYuklemeBilgi?.at?.(0)?.varisNokta ?? undefined,
      yuklemeplanaracislemleri_423966_value:
        this.state.Get_AracYuklemeBilgi?.at?.(0)?.brutAgirlilk ?? undefined,
      yuklemeplanaracislemleri_460914_value:
        this.state.Get_AracYuklemeBilgi?.at?.(0)?.kantarFarki ?? undefined,
      yuklemeplanaracislemleri_601643_value:
        this.state.Get_AracYuklemeBilgi?.at?.(0)?.kantarAgirlik ?? undefined,
      yuklemeplanaracislemleri_189286_value:
        this.state.Get_AracYuklemeBilgi?.at?.(0)?.kantarCikisAgirlik ??
        undefined,
      yuklemeplanaracislemleri_494956_value:
        this.state.Get_AracYuklemeBilgi?.at?.(0)?.aracGelisTarih ?? undefined,
      yuklemeplanaracislemleri_296908_value:
        this.state.Get_AracYuklemeBilgi?.at?.(0)?.aracYuklemeTarih ?? undefined,
      yuklemeplanaracislemleri_297996_value:
        this.state.Get_AracYuklemeBilgi?.at?.(0)?.aracCikisTarih ?? undefined,
    });
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  YuklemePlanAracIslemleriPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.ReadFromSessionStorage =
      await ReactSystemFunctions.readFromSessionStorage(
        ReactSystemFunctions.convertToTypeByName("FirmaNo", "string")
      );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.YuklemePlanAracIslemleriPageInit1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  YuklemePlanAracIslemleriPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      UserName_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUsername(),
        "string"
      ),
      FirmaNo_1: ReactSystemFunctions.convertToTypeByName(1002, "number"),
      ParametreAdi_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName(
          "MikroDagitimMailCC",
          "string"
        ),
        "string"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "YuklemePlanAracIslemleri/YuklemePlanAracIslemleriPageInit1_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.Get_Helpers_UserInfoByUserName =
      result?.data.get_Helpers_UserInfoByUserName;
    stateVars.isComp896232Visible =
      ReactSystemFunctions.isGreaterThan(
        ReactSystemFunctions.value(this, this.state.KantarFarkHesapla),
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Helpers_UserInfoByUserName !== undefined
            ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
              ? stateVars.Get_Helpers_UserInfoByUserName[0].kantarFarkiTolerans
              : null
            : this.state.Get_Helpers_UserInfoByUserName?.length > 0
            ? this.state.Get_Helpers_UserInfoByUserName[0].kantarFarkiTolerans
            : null
        )
      ) === true
        ? "visible"
        : "hidden";
    stateVars.Get_Firma_ParametreByName =
      result?.data.get_Firma_ParametreByName;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.YuklemePlanAracIslemleriPageInit2_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  YuklemePlanAracIslemleriPageInit2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.isComp896232Visible =
      ReactSystemFunctions.isGreaterThan(
        ReactSystemFunctions.value(this, this.state.KantarFarkHesapla),
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Helpers_UserInfoByUserName !== undefined
            ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
              ? stateVars.Get_Helpers_UserInfoByUserName[0].kantarFarkiTolerans
              : null
            : this.state.Get_Helpers_UserInfoByUserName?.length > 0
            ? this.state.Get_Helpers_UserInfoByUserName[0].kantarFarkiTolerans
            : null
        )
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp723285Enabled =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_AracYuklemeBilgi !== undefined
            ? stateVars.Get_AracYuklemeBilgi?.length > 0
              ? stateVars.Get_AracYuklemeBilgi[0].aracDurumKod
              : null
            : this.state.Get_AracYuklemeBilgi?.length > 0
            ? this.state.Get_AracYuklemeBilgi[0].aracDurumKod
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "enabled"
        : "disabled";
    stateVars.isComp826476Enabled =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_AracYuklemeBilgi !== undefined
            ? stateVars.Get_AracYuklemeBilgi?.length > 0
              ? stateVars.Get_AracYuklemeBilgi[0].aracDurumKod
              : null
            : this.state.Get_AracYuklemeBilgi?.length > 0
            ? this.state.Get_AracYuklemeBilgi[0].aracDurumKod
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "enabled"
        : "disabled";

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  YuklemePlanAracIslemleriComponent_359273_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Helpers_UserInfoByUserName !== undefined
            ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
              ? stateVars.Get_Helpers_UserInfoByUserName[0].firmaTipi
              : null
            : this.state.Get_Helpers_UserInfoByUserName?.length > 0
            ? this.state.Get_Helpers_UserInfoByUserName[0].firmaTipi
            : null
        ),
        "1"
      )
    ) {
      KuikaAppManager.showSpinner(this);

      KuikaAppManager.prepareForNavigation();

      stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
        this,
        this.YuklemePlanAracIslemleriComponent_359273_onClick1_,
        "YuklemePlanAracIslemleri",
        "LeftMenu",
        "",
        "7d969ddf-5801-4eb6-b92b-12be35bdd565",
        "584025",
        null,
        "left",
        "true",
        "380px",
        "100vh",
        true,
        false
      );

      this.props.form?.setFieldsValue(formVars);
      this.setState(stateVars);
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.YuklemePlanAracIslemleriComponent_359273_onClick1_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  YuklemePlanAracIslemleriComponent_359273_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Helpers_UserInfoByUserName !== undefined
            ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
              ? stateVars.Get_Helpers_UserInfoByUserName[0].firmaTipi
              : null
            : this.state.Get_Helpers_UserInfoByUserName?.length > 0
            ? this.state.Get_Helpers_UserInfoByUserName[0].firmaTipi
            : null
        ),
        "2"
      )
    ) {
      KuikaAppManager.prepareForNavigation();

      stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
        this,
        undefined,
        "YuklemePlanAracIslemleri",
        "LeftMenuYukVeren",
        "",
        "7d969ddf-5801-4eb6-b92b-12be35bdd565",
        "512589",
        null,
        "left",
        "true",
        "380px",
        "100vh",
        true,
        false
      );

      this.props.form?.setFieldsValue(formVars);
      this.setState(stateVars);
      KuikaAppManager.hideSpinner(this);
    } else {
      KuikaAppManager.hideSpinner(this);
    }

    return isErrorOccurred;
  };

  YuklemePlanAracIslemleriComponent_987747_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      FirmaNo_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(this, this.state.ReadFromSessionStorage),
        "number"
      ),
      TCKN_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "yuklemeplanaracislemleri_59594_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "YuklemePlanAracIslemleri/YuklemePlanAracIslemleriComponent_987747_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.Get_AracYuklemeBilgi = result?.data.get_AracYuklemeBilgi;
    formVars.yuklemeplanaracislemleri_887086_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.Get_AracYuklemeBilgi !== undefined
          ? stateVars.Get_AracYuklemeBilgi?.length > 0
            ? stateVars.Get_AracYuklemeBilgi[0].aracDurum
            : null
          : this.state.Get_AracYuklemeBilgi?.length > 0
          ? this.state.Get_AracYuklemeBilgi[0].aracDurum
          : null
      );
    formVars.yuklemeplanaracislemleri_312807_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.Get_AracYuklemeBilgi !== undefined
          ? stateVars.Get_AracYuklemeBilgi?.length > 0
            ? stateVars.Get_AracYuklemeBilgi[0].yuklemeNo
            : null
          : this.state.Get_AracYuklemeBilgi?.length > 0
          ? this.state.Get_AracYuklemeBilgi[0].yuklemeNo
          : null
      );
    formVars.yuklemeplanaracislemleri_268195_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.Get_AracYuklemeBilgi !== undefined
          ? stateVars.Get_AracYuklemeBilgi?.length > 0
            ? stateVars.Get_AracYuklemeBilgi[0].tasiyiciFirmaAdi
            : null
          : this.state.Get_AracYuklemeBilgi?.length > 0
          ? this.state.Get_AracYuklemeBilgi[0].tasiyiciFirmaAdi
          : null
      );
    formVars.yuklemeplanaracislemleri_515477_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.Get_AracYuklemeBilgi !== undefined
          ? stateVars.Get_AracYuklemeBilgi?.length > 0
            ? stateVars.Get_AracYuklemeBilgi[0].surucuAdi
            : null
          : this.state.Get_AracYuklemeBilgi?.length > 0
          ? this.state.Get_AracYuklemeBilgi[0].surucuAdi
          : null
      );
    formVars.yuklemeplanaracislemleri_975101_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.Get_AracYuklemeBilgi !== undefined
          ? stateVars.Get_AracYuklemeBilgi?.length > 0
            ? stateVars.Get_AracYuklemeBilgi[0].surucuGSM
            : null
          : this.state.Get_AracYuklemeBilgi?.length > 0
          ? this.state.Get_AracYuklemeBilgi[0].surucuGSM
          : null
      );
    formVars.yuklemeplanaracislemleri_739452_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.Get_AracYuklemeBilgi !== undefined
          ? stateVars.Get_AracYuklemeBilgi?.length > 0
            ? stateVars.Get_AracYuklemeBilgi[0].plaka
            : null
          : this.state.Get_AracYuklemeBilgi?.length > 0
          ? this.state.Get_AracYuklemeBilgi[0].plaka
          : null
      );
    formVars.yuklemeplanaracislemleri_571924_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.Get_AracYuklemeBilgi !== undefined
          ? stateVars.Get_AracYuklemeBilgi?.length > 0
            ? stateVars.Get_AracYuklemeBilgi[0].dorsePlaka
            : null
          : this.state.Get_AracYuklemeBilgi?.length > 0
          ? this.state.Get_AracYuklemeBilgi[0].dorsePlaka
          : null
      );
    formVars.yuklemeplanaracislemleri_275391_value = ReactSystemFunctions.value(
      this,
      stateVars.Get_AracYuklemeBilgi !== undefined
        ? stateVars.Get_AracYuklemeBilgi?.length > 0
          ? stateVars.Get_AracYuklemeBilgi[0].tahminiGelis
          : null
        : this.state.Get_AracYuklemeBilgi?.length > 0
        ? this.state.Get_AracYuklemeBilgi[0].tahminiGelis
        : null
    );
    formVars.yuklemeplanaracislemleri_267922_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.Get_AracYuklemeBilgi !== undefined
          ? stateVars.Get_AracYuklemeBilgi?.length > 0
            ? stateVars.Get_AracYuklemeBilgi[0].varisNokta
            : null
          : this.state.Get_AracYuklemeBilgi?.length > 0
          ? this.state.Get_AracYuklemeBilgi[0].varisNokta
          : null
      );
    formVars.yuklemeplanaracislemleri_423966_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.Get_AracYuklemeBilgi !== undefined
          ? stateVars.Get_AracYuklemeBilgi?.length > 0
            ? stateVars.Get_AracYuklemeBilgi[0].brutAgirlilk
            : null
          : this.state.Get_AracYuklemeBilgi?.length > 0
          ? this.state.Get_AracYuklemeBilgi[0].brutAgirlilk
          : null
      );
    formVars.yuklemeplanaracislemleri_460914_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.Get_AracYuklemeBilgi !== undefined
          ? stateVars.Get_AracYuklemeBilgi?.length > 0
            ? stateVars.Get_AracYuklemeBilgi[0].kantarFarki
            : null
          : this.state.Get_AracYuklemeBilgi?.length > 0
          ? this.state.Get_AracYuklemeBilgi[0].kantarFarki
          : null
      );
    formVars.yuklemeplanaracislemleri_601643_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.Get_AracYuklemeBilgi !== undefined
          ? stateVars.Get_AracYuklemeBilgi?.length > 0
            ? stateVars.Get_AracYuklemeBilgi[0].kantarAgirlik
            : null
          : this.state.Get_AracYuklemeBilgi?.length > 0
          ? this.state.Get_AracYuklemeBilgi[0].kantarAgirlik
          : null
      );
    formVars.yuklemeplanaracislemleri_189286_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.Get_AracYuklemeBilgi !== undefined
          ? stateVars.Get_AracYuklemeBilgi?.length > 0
            ? stateVars.Get_AracYuklemeBilgi[0].kantarCikisAgirlik
            : null
          : this.state.Get_AracYuklemeBilgi?.length > 0
          ? this.state.Get_AracYuklemeBilgi[0].kantarCikisAgirlik
          : null
      );
    formVars.yuklemeplanaracislemleri_494956_value = ReactSystemFunctions.value(
      this,
      stateVars.Get_AracYuklemeBilgi !== undefined
        ? stateVars.Get_AracYuklemeBilgi?.length > 0
          ? stateVars.Get_AracYuklemeBilgi[0].aracGelisTarih
          : null
        : this.state.Get_AracYuklemeBilgi?.length > 0
        ? this.state.Get_AracYuklemeBilgi[0].aracGelisTarih
        : null
    );
    formVars.yuklemeplanaracislemleri_296908_value = ReactSystemFunctions.value(
      this,
      stateVars.Get_AracYuklemeBilgi !== undefined
        ? stateVars.Get_AracYuklemeBilgi?.length > 0
          ? stateVars.Get_AracYuklemeBilgi[0].aracYuklemeTarih
          : null
        : this.state.Get_AracYuklemeBilgi?.length > 0
        ? this.state.Get_AracYuklemeBilgi[0].aracYuklemeTarih
        : null
    );
    formVars.yuklemeplanaracislemleri_297996_value = ReactSystemFunctions.value(
      this,
      stateVars.Get_AracYuklemeBilgi !== undefined
        ? stateVars.Get_AracYuklemeBilgi?.length > 0
          ? stateVars.Get_AracYuklemeBilgi[0].aracCikisTarih
          : null
        : this.state.Get_AracYuklemeBilgi?.length > 0
        ? this.state.Get_AracYuklemeBilgi[0].aracCikisTarih
        : null
    );
    stateVars.isComp723285Enabled =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_AracYuklemeBilgi !== undefined
            ? stateVars.Get_AracYuklemeBilgi?.length > 0
              ? stateVars.Get_AracYuklemeBilgi[0].aracDurumKod
              : null
            : this.state.Get_AracYuklemeBilgi?.length > 0
            ? this.state.Get_AracYuklemeBilgi[0].aracDurumKod
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "enabled"
        : "disabled";
    stateVars.isComp826476Enabled =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_AracYuklemeBilgi !== undefined
            ? stateVars.Get_AracYuklemeBilgi?.length > 0
              ? stateVars.Get_AracYuklemeBilgi[0].aracDurumKod
              : null
            : this.state.Get_AracYuklemeBilgi?.length > 0
            ? this.state.Get_AracYuklemeBilgi[0].aracDurumKod
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "enabled"
        : "disabled";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.YuklemePlanAracIslemleriComponent_987747_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  YuklemePlanAracIslemleriComponent_987747_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_AracYuklemeBilgi !== undefined
            ? stateVars.Get_AracYuklemeBilgi?.length > 0
              ? stateVars.Get_AracYuklemeBilgi[0].id
              : null
            : this.state.Get_AracYuklemeBilgi?.length > 0
            ? this.state.Get_AracYuklemeBilgi[0].id
            : null
        ),
        true
      )
    ) {
      stateVars.Notify = await ReactSystemFunctions.notify(
        this,
        ReactSystemFunctions.translateCustomActions(
          this.ml,
          "aeba720d_99ca_09aa_c7b3_f840b3ca82ee_notify",
          this.defaultML,
          "BU SÜRÜCÜYE AİT AÇIK YÜKLEME KAYDI BULUNAMADI !"
        ),
        ReactSystemFunctions.convertToTypeByName("danger", "string"),
        ReactSystemFunctions.convertToTypeByName("center", "string"),
        0,
        ReactSystemFunctions.convertToTypeByName("", "string"),
        ReactSystemFunctions.convertToTypeByName("", "string"),
        0
      );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.YuklemePlanAracIslemleriComponent_987747_onClick2_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.YuklemePlanAracIslemleriComponent_987747_onClick2_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  YuklemePlanAracIslemleriComponent_987747_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.yuklemeplanaracislemleri_887086_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.Get_AracYuklemeBilgi !== undefined
          ? stateVars.Get_AracYuklemeBilgi?.length > 0
            ? stateVars.Get_AracYuklemeBilgi[0].aracDurum
            : null
          : this.state.Get_AracYuklemeBilgi?.length > 0
          ? this.state.Get_AracYuklemeBilgi[0].aracDurum
          : null
      );

    formVars.yuklemeplanaracislemleri_312807_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.Get_AracYuklemeBilgi !== undefined
          ? stateVars.Get_AracYuklemeBilgi?.length > 0
            ? stateVars.Get_AracYuklemeBilgi[0].yuklemeNo
            : null
          : this.state.Get_AracYuklemeBilgi?.length > 0
          ? this.state.Get_AracYuklemeBilgi[0].yuklemeNo
          : null
      );

    formVars.yuklemeplanaracislemleri_268195_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.Get_AracYuklemeBilgi !== undefined
          ? stateVars.Get_AracYuklemeBilgi?.length > 0
            ? stateVars.Get_AracYuklemeBilgi[0].tasiyiciFirmaAdi
            : null
          : this.state.Get_AracYuklemeBilgi?.length > 0
          ? this.state.Get_AracYuklemeBilgi[0].tasiyiciFirmaAdi
          : null
      );

    formVars.yuklemeplanaracislemleri_515477_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.Get_AracYuklemeBilgi !== undefined
          ? stateVars.Get_AracYuklemeBilgi?.length > 0
            ? stateVars.Get_AracYuklemeBilgi[0].surucuAdi
            : null
          : this.state.Get_AracYuklemeBilgi?.length > 0
          ? this.state.Get_AracYuklemeBilgi[0].surucuAdi
          : null
      );

    formVars.yuklemeplanaracislemleri_975101_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.Get_AracYuklemeBilgi !== undefined
          ? stateVars.Get_AracYuklemeBilgi?.length > 0
            ? stateVars.Get_AracYuklemeBilgi[0].surucuGSM
            : null
          : this.state.Get_AracYuklemeBilgi?.length > 0
          ? this.state.Get_AracYuklemeBilgi[0].surucuGSM
          : null
      );

    formVars.yuklemeplanaracislemleri_739452_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.Get_AracYuklemeBilgi !== undefined
          ? stateVars.Get_AracYuklemeBilgi?.length > 0
            ? stateVars.Get_AracYuklemeBilgi[0].plaka
            : null
          : this.state.Get_AracYuklemeBilgi?.length > 0
          ? this.state.Get_AracYuklemeBilgi[0].plaka
          : null
      );

    formVars.yuklemeplanaracislemleri_571924_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.Get_AracYuklemeBilgi !== undefined
          ? stateVars.Get_AracYuklemeBilgi?.length > 0
            ? stateVars.Get_AracYuklemeBilgi[0].dorsePlaka
            : null
          : this.state.Get_AracYuklemeBilgi?.length > 0
          ? this.state.Get_AracYuklemeBilgi[0].dorsePlaka
          : null
      );

    formVars.yuklemeplanaracislemleri_275391_value = ReactSystemFunctions.value(
      this,
      stateVars.Get_AracYuklemeBilgi !== undefined
        ? stateVars.Get_AracYuklemeBilgi?.length > 0
          ? stateVars.Get_AracYuklemeBilgi[0].tahminiGelis
          : null
        : this.state.Get_AracYuklemeBilgi?.length > 0
        ? this.state.Get_AracYuklemeBilgi[0].tahminiGelis
        : null
    );

    formVars.yuklemeplanaracislemleri_267922_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.Get_AracYuklemeBilgi !== undefined
          ? stateVars.Get_AracYuklemeBilgi?.length > 0
            ? stateVars.Get_AracYuklemeBilgi[0].varisNokta
            : null
          : this.state.Get_AracYuklemeBilgi?.length > 0
          ? this.state.Get_AracYuklemeBilgi[0].varisNokta
          : null
      );

    formVars.yuklemeplanaracislemleri_423966_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.Get_AracYuklemeBilgi !== undefined
          ? stateVars.Get_AracYuklemeBilgi?.length > 0
            ? stateVars.Get_AracYuklemeBilgi[0].brutAgirlilk
            : null
          : this.state.Get_AracYuklemeBilgi?.length > 0
          ? this.state.Get_AracYuklemeBilgi[0].brutAgirlilk
          : null
      );

    formVars.yuklemeplanaracislemleri_460914_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.Get_AracYuklemeBilgi !== undefined
          ? stateVars.Get_AracYuklemeBilgi?.length > 0
            ? stateVars.Get_AracYuklemeBilgi[0].kantarFarki
            : null
          : this.state.Get_AracYuklemeBilgi?.length > 0
          ? this.state.Get_AracYuklemeBilgi[0].kantarFarki
          : null
      );

    formVars.yuklemeplanaracislemleri_601643_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.Get_AracYuklemeBilgi !== undefined
          ? stateVars.Get_AracYuklemeBilgi?.length > 0
            ? stateVars.Get_AracYuklemeBilgi[0].kantarAgirlik
            : null
          : this.state.Get_AracYuklemeBilgi?.length > 0
          ? this.state.Get_AracYuklemeBilgi[0].kantarAgirlik
          : null
      );

    formVars.yuklemeplanaracislemleri_189286_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.Get_AracYuklemeBilgi !== undefined
          ? stateVars.Get_AracYuklemeBilgi?.length > 0
            ? stateVars.Get_AracYuklemeBilgi[0].kantarCikisAgirlik
            : null
          : this.state.Get_AracYuklemeBilgi?.length > 0
          ? this.state.Get_AracYuklemeBilgi[0].kantarCikisAgirlik
          : null
      );

    formVars.yuklemeplanaracislemleri_494956_value = ReactSystemFunctions.value(
      this,
      stateVars.Get_AracYuklemeBilgi !== undefined
        ? stateVars.Get_AracYuklemeBilgi?.length > 0
          ? stateVars.Get_AracYuklemeBilgi[0].aracGelisTarih
          : null
        : this.state.Get_AracYuklemeBilgi?.length > 0
        ? this.state.Get_AracYuklemeBilgi[0].aracGelisTarih
        : null
    );

    formVars.yuklemeplanaracislemleri_296908_value = ReactSystemFunctions.value(
      this,
      stateVars.Get_AracYuklemeBilgi !== undefined
        ? stateVars.Get_AracYuklemeBilgi?.length > 0
          ? stateVars.Get_AracYuklemeBilgi[0].aracYuklemeTarih
          : null
        : this.state.Get_AracYuklemeBilgi?.length > 0
        ? this.state.Get_AracYuklemeBilgi[0].aracYuklemeTarih
        : null
    );

    formVars.yuklemeplanaracislemleri_297996_value = ReactSystemFunctions.value(
      this,
      stateVars.Get_AracYuklemeBilgi !== undefined
        ? stateVars.Get_AracYuklemeBilgi?.length > 0
          ? stateVars.Get_AracYuklemeBilgi[0].aracCikisTarih
          : null
        : this.state.Get_AracYuklemeBilgi?.length > 0
        ? this.state.Get_AracYuklemeBilgi[0].aracCikisTarih
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  YuklemePlanAracIslemleriComponent_896232_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      YuklemeNo_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "yuklemeplanaracislemleri_312807_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      Plaka_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "yuklemeplanaracislemleri_739452_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      YuklemeAgirlik_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "yuklemeplanaracislemleri_423966_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      KantarAgirlik_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "yuklemeplanaracislemleri_485178_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      Fark_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "yuklemeplanaracislemleri_460914_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      FirmaNo_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(this, this.state.ReadFromSessionStorage),
        "number"
      ),
      ParametreAdi_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("KantarFarkMailTo", "string"),
        "string"
      ),
      KantarAgirlik_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "yuklemeplanaracislemleri_189286_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      KantarFarki_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toDecimal(
          this,
          ReactSystemFunctions.value(
            this,
            "yuklemeplanaracislemleri_460914_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      UserId_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Helpers_UserInfoByUserName !== undefined
            ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
              ? stateVars.Get_Helpers_UserInfoByUserName[0].id
              : null
            : this.state.Get_Helpers_UserInfoByUserName?.length > 0
            ? this.state.Get_Helpers_UserInfoByUserName[0].id
            : null
        ),
        "Guid"
      ),
      YuklemeId_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_AracYuklemeBilgi !== undefined
            ? stateVars.Get_AracYuklemeBilgi?.length > 0
              ? stateVars.Get_AracYuklemeBilgi[0].id
              : null
            : this.state.Get_AracYuklemeBilgi?.length > 0
            ? this.state.Get_AracYuklemeBilgi[0].id
            : null
        ),
        "Guid"
      ),
      templateId_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      receivers_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.Get_Firma_ParametreByName !== undefined
            ? stateVars.Get_Firma_ParametreByName?.length > 0
              ? stateVars.Get_Firma_ParametreByName[0].parametreDegeri
              : null
            : this.state.Get_Firma_ParametreByName?.length > 0
            ? this.state.Get_Firma_ParametreByName[0].parametreDegeri
            : null
        ),
        "string"
      ),
      subject_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName(
          "Yükleme Plan - Kantar Farkı Bildirimi",
          "string"
        ),
        "string"
      ),
      sender_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      cc_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      bcc_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      language_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      body_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetAracKantarFarkMailBody
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "YuklemePlanAracIslemleri/YuklemePlanAracIslemleriComponent_896232_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetAracKantarFarkMailBody =
      result?.data.getAracKantarFarkMailBody;
    stateVars.Get_Firma_ParametreByName =
      result?.data.get_Firma_ParametreByName;
    stateVars.YuklemePlan_SaveKantarFark =
      result?.data.yuklemePlan_SaveKantarFark;
    stateVars.SendMail = result?.data.sendMail;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.YuklemePlanAracIslemleriComponent_896232_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  YuklemePlanAracIslemleriComponent_896232_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "0759af19_818b_0230_6c56_03710548d61d_notify",
        this.defaultML,
        "KANTAR FARKI BİLDİRİLDİ. ONAY GELMEDEN ÇIKIŞ YAPILAMAZ !"
      ),
      ReactSystemFunctions.convertToTypeByName("warning", "string"),
      ReactSystemFunctions.convertToTypeByName("center", "string"),
      0,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );
    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "YuklemePlanAracIslemleri",
      "HomePage",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  YuklemePlanAracIslemleriComponent_189286_onBlur = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.Subtract = await ReactSystemFunctions.subtract(
      ReactSystemFunctions.value(
        this,
        ReactSystemFunctions.value(
          this,
          "yuklemeplanaracislemleri_189286_value",
          "value",
          "",
          "",
          ""
        )
      ),
      ReactSystemFunctions.value(
        this,
        ReactSystemFunctions.value(
          this,
          "yuklemeplanaracislemleri_601643_value",
          "value",
          "",
          "",
          ""
        )
      )
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "yuklemeplanaracislemleri_485178_value",
        "string"
      ),
      ReactSystemFunctions.toString(this, stateVars.Subtract),
      null,
      false
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.YuklemePlanAracIslemleriComponent_189286_onBlur1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  YuklemePlanAracIslemleriComponent_189286_onBlur1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      KypAgirlik_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "yuklemeplanaracislemleri_423966_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      KantarNetAgirlik_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toDecimal(
          this,
          ReactSystemFunctions.value(
            this,
            "yuklemeplanaracislemleri_485178_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "YuklemePlanAracIslemleri/YuklemePlanAracIslemleriComponent_189286_onBlur1_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.KantarFarkHesapla = result?.data.kantarFarkHesapla;
    stateVars.isComp896232Visible =
      ReactSystemFunctions.isGreaterThan(
        ReactSystemFunctions.value(this, stateVars.KantarFarkHesapla),
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Helpers_UserInfoByUserName !== undefined
            ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
              ? stateVars.Get_Helpers_UserInfoByUserName[0].kantarFarkiTolerans
              : null
            : this.state.Get_Helpers_UserInfoByUserName?.length > 0
            ? this.state.Get_Helpers_UserInfoByUserName[0].kantarFarkiTolerans
            : null
        )
      ) === true
        ? "visible"
        : "hidden";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.YuklemePlanAracIslemleriComponent_189286_onBlur2_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  YuklemePlanAracIslemleriComponent_189286_onBlur2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "yuklemeplanaracislemleri_460914_value",
        "string"
      ),
      ReactSystemFunctions.toString(this, this.state.KantarFarkHesapla),
      null,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  YuklemePlanAracIslemleriComponent_723285_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      Islem_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("ARACGELDI", "string"),
        "string"
      ),
      UserId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Helpers_UserInfoByUserName !== undefined
            ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
              ? stateVars.Get_Helpers_UserInfoByUserName[0].id
              : null
            : this.state.Get_Helpers_UserInfoByUserName?.length > 0
            ? this.state.Get_Helpers_UserInfoByUserName[0].id
            : null
        ),
        "Guid"
      ),
      Id_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_AracYuklemeBilgi !== undefined
            ? stateVars.Get_AracYuklemeBilgi?.length > 0
              ? stateVars.Get_AracYuklemeBilgi[0].id
              : null
            : this.state.Get_AracYuklemeBilgi?.length > 0
            ? this.state.Get_AracYuklemeBilgi[0].id
            : null
        ),
        "Guid"
      ),
      GirisKantarAgirlik_0: ReactSystemFunctions.convertToTypeByName(
        0,
        "number"
      ),
      CikisKantarAgirlik_0: ReactSystemFunctions.convertToTypeByName(
        0,
        "number"
      ),
      FirmaNo_1: ReactSystemFunctions.convertToTypeByName(0, "number"),
      TCKN_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "yuklemeplanaracislemleri_59594_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "YuklemePlanAracIslemleri/YuklemePlanAracIslemleriComponent_723285_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.YuklemePlan_AracDurumGuncelle =
      result?.data.yuklemePlan_AracDurumGuncelle;
    stateVars.Get_AracYuklemeBilgi = result?.data.get_AracYuklemeBilgi;
    formVars.yuklemeplanaracislemleri_887086_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.Get_AracYuklemeBilgi !== undefined
          ? stateVars.Get_AracYuklemeBilgi?.length > 0
            ? stateVars.Get_AracYuklemeBilgi[0].aracDurum
            : null
          : this.state.Get_AracYuklemeBilgi?.length > 0
          ? this.state.Get_AracYuklemeBilgi[0].aracDurum
          : null
      );
    formVars.yuklemeplanaracislemleri_312807_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.Get_AracYuklemeBilgi !== undefined
          ? stateVars.Get_AracYuklemeBilgi?.length > 0
            ? stateVars.Get_AracYuklemeBilgi[0].yuklemeNo
            : null
          : this.state.Get_AracYuklemeBilgi?.length > 0
          ? this.state.Get_AracYuklemeBilgi[0].yuklemeNo
          : null
      );
    formVars.yuklemeplanaracislemleri_268195_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.Get_AracYuklemeBilgi !== undefined
          ? stateVars.Get_AracYuklemeBilgi?.length > 0
            ? stateVars.Get_AracYuklemeBilgi[0].tasiyiciFirmaAdi
            : null
          : this.state.Get_AracYuklemeBilgi?.length > 0
          ? this.state.Get_AracYuklemeBilgi[0].tasiyiciFirmaAdi
          : null
      );
    formVars.yuklemeplanaracislemleri_515477_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.Get_AracYuklemeBilgi !== undefined
          ? stateVars.Get_AracYuklemeBilgi?.length > 0
            ? stateVars.Get_AracYuklemeBilgi[0].surucuAdi
            : null
          : this.state.Get_AracYuklemeBilgi?.length > 0
          ? this.state.Get_AracYuklemeBilgi[0].surucuAdi
          : null
      );
    formVars.yuklemeplanaracislemleri_975101_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.Get_AracYuklemeBilgi !== undefined
          ? stateVars.Get_AracYuklemeBilgi?.length > 0
            ? stateVars.Get_AracYuklemeBilgi[0].surucuGSM
            : null
          : this.state.Get_AracYuklemeBilgi?.length > 0
          ? this.state.Get_AracYuklemeBilgi[0].surucuGSM
          : null
      );
    formVars.yuklemeplanaracislemleri_739452_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.Get_AracYuklemeBilgi !== undefined
          ? stateVars.Get_AracYuklemeBilgi?.length > 0
            ? stateVars.Get_AracYuklemeBilgi[0].plaka
            : null
          : this.state.Get_AracYuklemeBilgi?.length > 0
          ? this.state.Get_AracYuklemeBilgi[0].plaka
          : null
      );
    formVars.yuklemeplanaracislemleri_571924_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.Get_AracYuklemeBilgi !== undefined
          ? stateVars.Get_AracYuklemeBilgi?.length > 0
            ? stateVars.Get_AracYuklemeBilgi[0].dorsePlaka
            : null
          : this.state.Get_AracYuklemeBilgi?.length > 0
          ? this.state.Get_AracYuklemeBilgi[0].dorsePlaka
          : null
      );
    formVars.yuklemeplanaracislemleri_275391_value = ReactSystemFunctions.value(
      this,
      stateVars.Get_AracYuklemeBilgi !== undefined
        ? stateVars.Get_AracYuklemeBilgi?.length > 0
          ? stateVars.Get_AracYuklemeBilgi[0].tahminiGelis
          : null
        : this.state.Get_AracYuklemeBilgi?.length > 0
        ? this.state.Get_AracYuklemeBilgi[0].tahminiGelis
        : null
    );
    formVars.yuklemeplanaracislemleri_267922_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.Get_AracYuklemeBilgi !== undefined
          ? stateVars.Get_AracYuklemeBilgi?.length > 0
            ? stateVars.Get_AracYuklemeBilgi[0].varisNokta
            : null
          : this.state.Get_AracYuklemeBilgi?.length > 0
          ? this.state.Get_AracYuklemeBilgi[0].varisNokta
          : null
      );
    formVars.yuklemeplanaracislemleri_423966_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.Get_AracYuklemeBilgi !== undefined
          ? stateVars.Get_AracYuklemeBilgi?.length > 0
            ? stateVars.Get_AracYuklemeBilgi[0].brutAgirlilk
            : null
          : this.state.Get_AracYuklemeBilgi?.length > 0
          ? this.state.Get_AracYuklemeBilgi[0].brutAgirlilk
          : null
      );
    formVars.yuklemeplanaracislemleri_460914_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.Get_AracYuklemeBilgi !== undefined
          ? stateVars.Get_AracYuklemeBilgi?.length > 0
            ? stateVars.Get_AracYuklemeBilgi[0].kantarFarki
            : null
          : this.state.Get_AracYuklemeBilgi?.length > 0
          ? this.state.Get_AracYuklemeBilgi[0].kantarFarki
          : null
      );
    formVars.yuklemeplanaracislemleri_601643_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.Get_AracYuklemeBilgi !== undefined
          ? stateVars.Get_AracYuklemeBilgi?.length > 0
            ? stateVars.Get_AracYuklemeBilgi[0].kantarAgirlik
            : null
          : this.state.Get_AracYuklemeBilgi?.length > 0
          ? this.state.Get_AracYuklemeBilgi[0].kantarAgirlik
          : null
      );
    formVars.yuklemeplanaracislemleri_189286_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.Get_AracYuklemeBilgi !== undefined
          ? stateVars.Get_AracYuklemeBilgi?.length > 0
            ? stateVars.Get_AracYuklemeBilgi[0].kantarCikisAgirlik
            : null
          : this.state.Get_AracYuklemeBilgi?.length > 0
          ? this.state.Get_AracYuklemeBilgi[0].kantarCikisAgirlik
          : null
      );
    formVars.yuklemeplanaracislemleri_494956_value = ReactSystemFunctions.value(
      this,
      stateVars.Get_AracYuklemeBilgi !== undefined
        ? stateVars.Get_AracYuklemeBilgi?.length > 0
          ? stateVars.Get_AracYuklemeBilgi[0].aracGelisTarih
          : null
        : this.state.Get_AracYuklemeBilgi?.length > 0
        ? this.state.Get_AracYuklemeBilgi[0].aracGelisTarih
        : null
    );
    formVars.yuklemeplanaracislemleri_296908_value = ReactSystemFunctions.value(
      this,
      stateVars.Get_AracYuklemeBilgi !== undefined
        ? stateVars.Get_AracYuklemeBilgi?.length > 0
          ? stateVars.Get_AracYuklemeBilgi[0].aracYuklemeTarih
          : null
        : this.state.Get_AracYuklemeBilgi?.length > 0
        ? this.state.Get_AracYuklemeBilgi[0].aracYuklemeTarih
        : null
    );
    formVars.yuklemeplanaracislemleri_297996_value = ReactSystemFunctions.value(
      this,
      stateVars.Get_AracYuklemeBilgi !== undefined
        ? stateVars.Get_AracYuklemeBilgi?.length > 0
          ? stateVars.Get_AracYuklemeBilgi[0].aracCikisTarih
          : null
        : this.state.Get_AracYuklemeBilgi?.length > 0
        ? this.state.Get_AracYuklemeBilgi[0].aracCikisTarih
        : null
    );
    stateVars.isComp723285Enabled =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_AracYuklemeBilgi !== undefined
            ? stateVars.Get_AracYuklemeBilgi?.length > 0
              ? stateVars.Get_AracYuklemeBilgi[0].aracDurumKod
              : null
            : this.state.Get_AracYuklemeBilgi?.length > 0
            ? this.state.Get_AracYuklemeBilgi[0].aracDurumKod
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "enabled"
        : "disabled";
    stateVars.isComp826476Enabled =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_AracYuklemeBilgi !== undefined
            ? stateVars.Get_AracYuklemeBilgi?.length > 0
              ? stateVars.Get_AracYuklemeBilgi[0].aracDurumKod
              : null
            : this.state.Get_AracYuklemeBilgi?.length > 0
            ? this.state.Get_AracYuklemeBilgi[0].aracDurumKod
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "enabled"
        : "disabled";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.YuklemePlanAracIslemleriComponent_723285_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  YuklemePlanAracIslemleriComponent_723285_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      this.YuklemePlanAracIslemleriComponent_723285_onClick2_,
      "YuklemePlanAracIslemleri",
      "YuklemePlanAracBeklemeListesi",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };
  YuklemePlanAracIslemleriComponent_723285_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.yuklemeplanaracislemleri_887086_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.Get_AracYuklemeBilgi !== undefined
          ? stateVars.Get_AracYuklemeBilgi?.length > 0
            ? stateVars.Get_AracYuklemeBilgi[0].aracDurum
            : null
          : this.state.Get_AracYuklemeBilgi?.length > 0
          ? this.state.Get_AracYuklemeBilgi[0].aracDurum
          : null
      );

    formVars.yuklemeplanaracislemleri_312807_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.Get_AracYuklemeBilgi !== undefined
          ? stateVars.Get_AracYuklemeBilgi?.length > 0
            ? stateVars.Get_AracYuklemeBilgi[0].yuklemeNo
            : null
          : this.state.Get_AracYuklemeBilgi?.length > 0
          ? this.state.Get_AracYuklemeBilgi[0].yuklemeNo
          : null
      );

    formVars.yuklemeplanaracislemleri_268195_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.Get_AracYuklemeBilgi !== undefined
          ? stateVars.Get_AracYuklemeBilgi?.length > 0
            ? stateVars.Get_AracYuklemeBilgi[0].tasiyiciFirmaAdi
            : null
          : this.state.Get_AracYuklemeBilgi?.length > 0
          ? this.state.Get_AracYuklemeBilgi[0].tasiyiciFirmaAdi
          : null
      );

    formVars.yuklemeplanaracislemleri_515477_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.Get_AracYuklemeBilgi !== undefined
          ? stateVars.Get_AracYuklemeBilgi?.length > 0
            ? stateVars.Get_AracYuklemeBilgi[0].surucuAdi
            : null
          : this.state.Get_AracYuklemeBilgi?.length > 0
          ? this.state.Get_AracYuklemeBilgi[0].surucuAdi
          : null
      );

    formVars.yuklemeplanaracislemleri_975101_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.Get_AracYuklemeBilgi !== undefined
          ? stateVars.Get_AracYuklemeBilgi?.length > 0
            ? stateVars.Get_AracYuklemeBilgi[0].surucuGSM
            : null
          : this.state.Get_AracYuklemeBilgi?.length > 0
          ? this.state.Get_AracYuklemeBilgi[0].surucuGSM
          : null
      );

    formVars.yuklemeplanaracislemleri_739452_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.Get_AracYuklemeBilgi !== undefined
          ? stateVars.Get_AracYuklemeBilgi?.length > 0
            ? stateVars.Get_AracYuklemeBilgi[0].plaka
            : null
          : this.state.Get_AracYuklemeBilgi?.length > 0
          ? this.state.Get_AracYuklemeBilgi[0].plaka
          : null
      );

    formVars.yuklemeplanaracislemleri_571924_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.Get_AracYuklemeBilgi !== undefined
          ? stateVars.Get_AracYuklemeBilgi?.length > 0
            ? stateVars.Get_AracYuklemeBilgi[0].dorsePlaka
            : null
          : this.state.Get_AracYuklemeBilgi?.length > 0
          ? this.state.Get_AracYuklemeBilgi[0].dorsePlaka
          : null
      );

    formVars.yuklemeplanaracislemleri_275391_value = ReactSystemFunctions.value(
      this,
      stateVars.Get_AracYuklemeBilgi !== undefined
        ? stateVars.Get_AracYuklemeBilgi?.length > 0
          ? stateVars.Get_AracYuklemeBilgi[0].tahminiGelis
          : null
        : this.state.Get_AracYuklemeBilgi?.length > 0
        ? this.state.Get_AracYuklemeBilgi[0].tahminiGelis
        : null
    );

    formVars.yuklemeplanaracislemleri_267922_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.Get_AracYuklemeBilgi !== undefined
          ? stateVars.Get_AracYuklemeBilgi?.length > 0
            ? stateVars.Get_AracYuklemeBilgi[0].varisNokta
            : null
          : this.state.Get_AracYuklemeBilgi?.length > 0
          ? this.state.Get_AracYuklemeBilgi[0].varisNokta
          : null
      );

    formVars.yuklemeplanaracislemleri_423966_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.Get_AracYuklemeBilgi !== undefined
          ? stateVars.Get_AracYuklemeBilgi?.length > 0
            ? stateVars.Get_AracYuklemeBilgi[0].brutAgirlilk
            : null
          : this.state.Get_AracYuklemeBilgi?.length > 0
          ? this.state.Get_AracYuklemeBilgi[0].brutAgirlilk
          : null
      );

    formVars.yuklemeplanaracislemleri_460914_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.Get_AracYuklemeBilgi !== undefined
          ? stateVars.Get_AracYuklemeBilgi?.length > 0
            ? stateVars.Get_AracYuklemeBilgi[0].kantarFarki
            : null
          : this.state.Get_AracYuklemeBilgi?.length > 0
          ? this.state.Get_AracYuklemeBilgi[0].kantarFarki
          : null
      );

    formVars.yuklemeplanaracislemleri_601643_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.Get_AracYuklemeBilgi !== undefined
          ? stateVars.Get_AracYuklemeBilgi?.length > 0
            ? stateVars.Get_AracYuklemeBilgi[0].kantarAgirlik
            : null
          : this.state.Get_AracYuklemeBilgi?.length > 0
          ? this.state.Get_AracYuklemeBilgi[0].kantarAgirlik
          : null
      );

    formVars.yuklemeplanaracislemleri_189286_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.Get_AracYuklemeBilgi !== undefined
          ? stateVars.Get_AracYuklemeBilgi?.length > 0
            ? stateVars.Get_AracYuklemeBilgi[0].kantarCikisAgirlik
            : null
          : this.state.Get_AracYuklemeBilgi?.length > 0
          ? this.state.Get_AracYuklemeBilgi[0].kantarCikisAgirlik
          : null
      );

    formVars.yuklemeplanaracislemleri_494956_value = ReactSystemFunctions.value(
      this,
      stateVars.Get_AracYuklemeBilgi !== undefined
        ? stateVars.Get_AracYuklemeBilgi?.length > 0
          ? stateVars.Get_AracYuklemeBilgi[0].aracGelisTarih
          : null
        : this.state.Get_AracYuklemeBilgi?.length > 0
        ? this.state.Get_AracYuklemeBilgi[0].aracGelisTarih
        : null
    );

    formVars.yuklemeplanaracislemleri_296908_value = ReactSystemFunctions.value(
      this,
      stateVars.Get_AracYuklemeBilgi !== undefined
        ? stateVars.Get_AracYuklemeBilgi?.length > 0
          ? stateVars.Get_AracYuklemeBilgi[0].aracYuklemeTarih
          : null
        : this.state.Get_AracYuklemeBilgi?.length > 0
        ? this.state.Get_AracYuklemeBilgi[0].aracYuklemeTarih
        : null
    );

    formVars.yuklemeplanaracislemleri_297996_value = ReactSystemFunctions.value(
      this,
      stateVars.Get_AracYuklemeBilgi !== undefined
        ? stateVars.Get_AracYuklemeBilgi?.length > 0
          ? stateVars.Get_AracYuklemeBilgi[0].aracCikisTarih
          : null
        : this.state.Get_AracYuklemeBilgi?.length > 0
        ? this.state.Get_AracYuklemeBilgi[0].aracCikisTarih
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  YuklemePlanAracIslemleriComponent_826476_onClick_if0 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      Islem_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("YUKLEMEYEALINDI", "string"),
        "string"
      ),
      UserId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Helpers_UserInfoByUserName !== undefined
            ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
              ? stateVars.Get_Helpers_UserInfoByUserName[0].id
              : null
            : this.state.Get_Helpers_UserInfoByUserName?.length > 0
            ? this.state.Get_Helpers_UserInfoByUserName[0].id
            : null
        ),
        "Guid"
      ),
      Id_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_AracYuklemeBilgi !== undefined
            ? stateVars.Get_AracYuklemeBilgi?.length > 0
              ? stateVars.Get_AracYuklemeBilgi[0].id
              : null
            : this.state.Get_AracYuklemeBilgi?.length > 0
            ? this.state.Get_AracYuklemeBilgi[0].id
            : null
        ),
        "Guid"
      ),
      GirisKantarAgirlik_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "yuklemeplanaracislemleri_601643_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      CikisKantarAgirlik_0: ReactSystemFunctions.convertToTypeByName(
        0,
        "number"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "YuklemePlanAracIslemleri/YuklemePlanAracIslemleriComponent_826476_onClick_if0",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.YuklemePlan_AracDurumGuncelle =
      result?.data.yuklemePlan_AracDurumGuncelle;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.YuklemePlanAracIslemleriComponent_826476_onClick_if01_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  YuklemePlanAracIslemleriComponent_826476_onClick_if01_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "YuklemePlanAracIslemleri",
      "YuklemePlanAracBeklemeListesi",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  YuklemePlanAracIslemleriComponent_826476_onClick_else0 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "312dbe68_3de1_d3c1_9dbf_0e3b4daa874a_notify",
        this.defaultML,
        "Boş ağırlık girilmeden araç yüklemeye giremez !"
      ),
      ReactSystemFunctions.convertToTypeByName("danger", "string"),
      ReactSystemFunctions.convertToTypeByName("center", "string"),
      0,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  YuklemePlanAracIslemleriComponent_826476_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isGreaterThan(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "yuklemeplanaracislemleri_601643_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "0"
      )
    ) {
      isErrorOccurred =
        await this.YuklemePlanAracIslemleriComponent_826476_onClick_if0();
      if (isErrorOccurred) return true;
    } else {
      isErrorOccurred =
        await this.YuklemePlanAracIslemleriComponent_826476_onClick_else0();
      if (isErrorOccurred) return true;
    }
    KuikaAppManager.showSpinner(this);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  YuklemePlanAracIslemleriComponent_314442_onClick_if0 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      YuklemeId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_AracYuklemeBilgi !== undefined
            ? stateVars.Get_AracYuklemeBilgi?.length > 0
              ? stateVars.Get_AracYuklemeBilgi[0].id
              : null
            : this.state.Get_AracYuklemeBilgi?.length > 0
            ? this.state.Get_AracYuklemeBilgi[0].id
            : null
        ),
        "Guid"
      ),
      TeslimatNo_0: ReactSystemFunctions.convertToTypeByName(0, "number"),
      SmsLinkCode_0: ReactSystemFunctions.convertToTypeByName("", "string"),
      Islem_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("KAPICIKIS", "string"),
        "string"
      ),
      UserId_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Helpers_UserInfoByUserName !== undefined
            ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
              ? stateVars.Get_Helpers_UserInfoByUserName[0].id
              : null
            : this.state.Get_Helpers_UserInfoByUserName?.length > 0
            ? this.state.Get_Helpers_UserInfoByUserName[0].id
            : null
        ),
        "Guid"
      ),
      Id_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_AracYuklemeBilgi !== undefined
            ? stateVars.Get_AracYuklemeBilgi?.length > 0
              ? stateVars.Get_AracYuklemeBilgi[0].id
              : null
            : this.state.Get_AracYuklemeBilgi?.length > 0
            ? this.state.Get_AracYuklemeBilgi[0].id
            : null
        ),
        "Guid"
      ),
      GirisKantarAgirlik_1: ReactSystemFunctions.convertToTypeByName(
        0,
        "number"
      ),
      CikisKantarAgirlik_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "yuklemeplanaracislemleri_189286_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      YuklemeId_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_AracYuklemeBilgi !== undefined
            ? stateVars.Get_AracYuklemeBilgi?.length > 0
              ? stateVars.Get_AracYuklemeBilgi[0].id
              : null
            : this.state.Get_AracYuklemeBilgi?.length > 0
            ? this.state.Get_AracYuklemeBilgi[0].id
            : null
        ),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "YuklemePlanAracIslemleri/YuklemePlanAracIslemleriComponent_314442_onClick_if0",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.YuklemePlan_SaveSmsLink = result?.data.yuklemePlan_SaveSmsLink;
    stateVars.YuklemePlan_AracDurumGuncelle =
      result?.data.yuklemePlan_AracDurumGuncelle;
    stateVars.GetTextForSMS = result?.data.getTextForSMS;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.YuklemePlanAracIslemleriComponent_314442_onClick_if01_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  YuklemePlanAracIslemleriComponent_314442_onClick_if0each1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      _Username_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.Get_Helpers_UserInfoByUserName !== undefined
            ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
              ? stateVars.Get_Helpers_UserInfoByUserName[0].smsUserName
              : null
            : this.state.Get_Helpers_UserInfoByUserName?.length > 0
            ? this.state.Get_Helpers_UserInfoByUserName[0].smsUserName
            : null
        ),
        "string"
      ),
      _Password_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.Get_Helpers_UserInfoByUserName !== undefined
            ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
              ? stateVars.Get_Helpers_UserInfoByUserName[0].smsPassword
              : null
            : this.state.Get_Helpers_UserInfoByUserName?.length > 0
            ? this.state.Get_Helpers_UserInfoByUserName[0].smsPassword
            : null
        ),
        "string"
      ),
      number_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "yuklemeplanaracislemleri_975101_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      title_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName(
          "YUKLEME PLANI BİLDİRİMİ",
          "string"
        ),
        "string"
      ),
      content_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, this.ForEach2?.smsText),
        "string"
      ),
      sender_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.Get_Helpers_UserInfoByUserName !== undefined
            ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
              ? stateVars.Get_Helpers_UserInfoByUserName[0].smsSenderName
              : null
            : this.state.Get_Helpers_UserInfoByUserName?.length > 0
            ? this.state.Get_Helpers_UserInfoByUserName[0].smsSenderName
            : null
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "YuklemePlanAracIslemleri/YuklemePlanAracIslemleriComponent_314442_onClick_if0each1",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.Sms_Send = result?.data.sms_Send;
    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };

  YuklemePlanAracIslemleriComponent_314442_onClick_if01_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Helpers_UserInfoByUserName !== undefined
            ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
              ? stateVars.Get_Helpers_UserInfoByUserName[0].smsLisans
              : null
            : this.state.Get_Helpers_UserInfoByUserName?.length > 0
            ? this.state.Get_Helpers_UserInfoByUserName[0].smsLisans
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      )
    ) {
      if (ReactSystemFunctions.value(this, this.state.GetTextForSMS)?.length) {
        for (let item of ReactSystemFunctions.value(
          this,
          this.state.GetTextForSMS
        )) {
          this.ForEach2 = item;
          await this.YuklemePlanAracIslemleriComponent_314442_onClick_if0each1();
        }
      }

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.YuklemePlanAracIslemleriComponent_314442_onClick_if02_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.YuklemePlanAracIslemleriComponent_314442_onClick_if02_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  YuklemePlanAracIslemleriComponent_314442_onClick_if02_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      SmsSent_0: ReactSystemFunctions.convertToTypeByName(true, "boolean"),
      SmsSonuc_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, this.state.Sms_Send),
        "string"
      ),
      UserId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Helpers_UserInfoByUserName !== undefined
            ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
              ? stateVars.Get_Helpers_UserInfoByUserName[0].id
              : null
            : this.state.Get_Helpers_UserInfoByUserName?.length > 0
            ? this.state.Get_Helpers_UserInfoByUserName[0].id
            : null
        ),
        "Guid"
      ),
      YuklemeId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_AracYuklemeBilgi !== undefined
            ? stateVars.Get_AracYuklemeBilgi?.length > 0
              ? stateVars.Get_AracYuklemeBilgi[0].id
              : null
            : this.state.Get_AracYuklemeBilgi?.length > 0
            ? this.state.Get_AracYuklemeBilgi[0].id
            : null
        ),
        "Guid"
      ),
      FirmaNo_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(this, this.state.ReadFromSessionStorage),
        "number"
      ),
      YuklemeNo_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.Get_AracYuklemeBilgi !== undefined
            ? stateVars.Get_AracYuklemeBilgi?.length > 0
              ? stateVars.Get_AracYuklemeBilgi[0].yuklemeNo
              : null
            : this.state.Get_AracYuklemeBilgi?.length > 0
            ? this.state.Get_AracYuklemeBilgi[0].yuklemeNo
            : null
        ),
        "string"
      ),
      YuklemeNo_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.Get_AracYuklemeBilgi !== undefined
            ? stateVars.Get_AracYuklemeBilgi?.length > 0
              ? stateVars.Get_AracYuklemeBilgi[0].yuklemeNo
              : null
            : this.state.Get_AracYuklemeBilgi?.length > 0
            ? this.state.Get_AracYuklemeBilgi[0].yuklemeNo
            : null
        ),
        "string"
      ),
      FirmaNo_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(this, this.state.ReadFromSessionStorage),
        "number"
      ),
      FirmaAdi_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.Get_Helpers_UserInfoByUserName !== undefined
            ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
              ? stateVars.Get_Helpers_UserInfoByUserName[0].firmaAdi
              : null
            : this.state.Get_Helpers_UserInfoByUserName?.length > 0
            ? this.state.Get_Helpers_UserInfoByUserName[0].firmaAdi
            : null
        ),
        "string"
      ),
      MailBody_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.YuklemePlan_Get_MikroDagitimNoktaListe !== undefined
            ? stateVars.YuklemePlan_Get_MikroDagitimNoktaListe?.length > 0
              ? stateVars.YuklemePlan_Get_MikroDagitimNoktaListe[0].mailTablo
              : null
            : this.state.YuklemePlan_Get_MikroDagitimNoktaListe?.length > 0
            ? this.state.YuklemePlan_Get_MikroDagitimNoktaListe[0].mailTablo
            : null
        ),
        "string"
      ),
      templateId_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      receivers_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.YuklemePlan_Get_MikroDagitimDepoListe !== undefined
            ? stateVars.YuklemePlan_Get_MikroDagitimDepoListe?.length > 0
              ? stateVars.YuklemePlan_Get_MikroDagitimDepoListe[0]
                  .dagitimDepoEPosta
              : null
            : this.state.YuklemePlan_Get_MikroDagitimDepoListe?.length > 0
            ? this.state.YuklemePlan_Get_MikroDagitimDepoListe[0]
                .dagitimDepoEPosta
            : null
        ),
        "string"
      ),
      subject_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName(
          "Yükleme Planı - Mikro Dağıtım Detayları",
          "string"
        ),
        "string"
      ),
      sender_4: ReactSystemFunctions.convertToTypeByName("", "string"),
      cc_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.Get_Firma_ParametreByName !== undefined
            ? stateVars.Get_Firma_ParametreByName?.length > 0
              ? stateVars.Get_Firma_ParametreByName[0].parametreDegeri
              : null
            : this.state.Get_Firma_ParametreByName?.length > 0
            ? this.state.Get_Firma_ParametreByName[0].parametreDegeri
            : null
        ),
        "string"
      ),
      bcc_4: ReactSystemFunctions.convertToTypeByName("", "string"),
      fileAttachments_4: ReactSystemFunctions.convertToTypeByName(``, "string"),
      language_4: ReactSystemFunctions.convertToTypeByName("", "string"),
      body_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetMailBody_MikroDagitimDepoBilgilendirme
        ),
        "string"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "YuklemePlanAracIslemleri/YuklemePlanAracIslemleriComponent_314442_onClick_if02_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.YuklemePlan_SaveSmsResult =
      result?.data.yuklemePlan_SaveSmsResult;
    stateVars.YuklemePlan_Get_MikroDagitimDepoListe =
      result?.data.yuklemePlan_Get_MikroDagitimDepoListe;
    stateVars.YuklemePlan_Get_MikroDagitimNoktaListe =
      result?.data.yuklemePlan_Get_MikroDagitimNoktaListe;
    stateVars.GetMailBody_MikroDagitimDepoBilgilendirme =
      result?.data.getMailBody_MikroDagitimDepoBilgilendirme;
    stateVars.SendMail = result?.data.sendMail;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.YuklemePlanAracIslemleriComponent_314442_onClick_if03_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  YuklemePlanAracIslemleriComponent_314442_onClick_if03_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "YuklemePlanAracIslemleri",
      "YuklemePlanAracBeklemeListesi",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  YuklemePlanAracIslemleriComponent_314442_onClick_else0 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "1112efd3_5cb3_5013_b454_5017c6a46523_notify",
        this.defaultML,
        "KANTAR FARKI ONAYLANMAYAN ARAÇ ÇIKIŞ YAPAMAZ !"
      ),
      ReactSystemFunctions.convertToTypeByName("danger", "string"),
      ReactSystemFunctions.convertToTypeByName("center", "string"),
      0,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );
    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.toString(this, this.state.KantarFarkHesapla),
      ReactSystemFunctions.convertToTypeByName("default", "string"),
      ReactSystemFunctions.convertToTypeByName("bottom-right", "string"),
      0,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  YuklemePlanAracIslemleriComponent_314442_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_AracYuklemeBilgi !== undefined
            ? stateVars.Get_AracYuklemeBilgi?.length > 0
              ? stateVars.Get_AracYuklemeBilgi[0].kantarFarkOnay
              : null
            : this.state.Get_AracYuklemeBilgi?.length > 0
            ? this.state.Get_AracYuklemeBilgi[0].kantarFarkOnay
            : null
        ),
        true
      ) ||
      ReactSystemFunctions.isLessOrEqual(
        ReactSystemFunctions.value(this, this.state.KantarFarkHesapla),
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Helpers_UserInfoByUserName !== undefined
            ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
              ? stateVars.Get_Helpers_UserInfoByUserName[0].kantarFarkiTolerans
              : null
            : this.state.Get_Helpers_UserInfoByUserName?.length > 0
            ? this.state.Get_Helpers_UserInfoByUserName[0].kantarFarkiTolerans
            : null
        )
      )
    ) {
      isErrorOccurred =
        await this.YuklemePlanAracIslemleriComponent_314442_onClick_if0();
      if (isErrorOccurred) return true;
    } else {
      isErrorOccurred =
        await this.YuklemePlanAracIslemleriComponent_314442_onClick_else0();
      if (isErrorOccurred) return true;
    }
    KuikaAppManager.showSpinner(this);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [584025, 512589, , , ,] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.YuklemePlanAracIslemleriPageInit();
    }
    if (diId == 584025) {
      isErrorOccurred =
        await this.YuklemePlanAracIslemleriComponent_359273_onClick1_();
      if (isErrorOccurred) return true;
    }
  }
}
